<template>
  <b-card title="تسویه حساب">
    <b-modal
      id="settlment"
      title="تسویه حساب"
      @ok.prevent="save"
      ok-title="ذخیره"
      cancel-title="انصراف"
    >
      <div v-if="activeGateway != null">
        <b-form-group label="شماره شبا ی واریز وجه:">
          <div class="form-control text-right" style="word-spacing: 6px">
            {{ activeGateway.shaba_number.match(/.{1,4}/g).join("  ") }}
          </div>
        </b-form-group>
        <b-form-group label="موجودی قابل برداشت:">
          <div class="form-control text-right" style="word-spacing: 6px">
            {{ Number(activeGateway.willpayfuture).toLocaleString() }}
          </div>
        </b-form-group>
        <b-form-group label="مبلغ درخواستی:">
          <number-seprator
            class="text-right"
            v-model="activeGateway.amount"
          ></number-seprator>
        </b-form-group>
      </div>
    </b-modal>
    <b-row>
      <div class="col-md-4" v-for="item in gateways" v-bind:key="item.id">
        <b-card
          no-body
          class="mt-2"
          style="cursor: pointer"
        >
          <b-card-body>
            <div class="row">
              <div class="col-md-3 col-sm-3">
                <b-img
                  :src="'http://api.shepa.com/api/file/' + item.logo"
                  fluid
                ></b-img>
              </div>
              <div class="col-md-9 col-sm-9">
                <h4>{{ item.website_name }}</h4>
                <div class="mt-2">
                  موجودی حساب:
                  <p class="text-bold text-left mb-0">
                    {{ Number(item.willpaytomarow).toLocaleString() }} ريال
                  </p>
                </div>
                <div class="mt-2">
                  موجودی قابل برداشت:
                  <p class="text-bold text-left mb-0">
                    {{ Number(item.willpayfuture).toLocaleString() }} ريال
                  </p>
                </div>
                <div class="mt-2">
                  موجودی در حال تسویه:
                  <p class="text-bold text-left mb-0">
                    {{ Number(item.waiting).toLocaleString() }} ريال
                  </p>
                </div>
                <div class="mt-2">
                  <p class="text-right mb-0">
                    <b-button variant="success" :disabled="item.willpayfuture==0" @click="SetActiveGateway(item)">تسویه</b-button>
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import numberSeprator from "../../components/numberSeprator.vue";
export default {
  components: { numberSeprator },
  name: "Settle",
  data() {
    return {
      gateways: [],
      activeGateway: null,
    };
  },
  methods: {
    SetActiveGateway(gateway) {
      this.activeGateway = gateway;
      this.activeGateway.amount = 0;
      this.$bvModal.show("settlment");
    },
    save() {
      httpHelper.postData("settlementRequest", this.activeGateway).then((res) => {
        this.$bvModal.hide("settlment");
        this.getdata();
      });
    },
    getdata() {
      httpHelper.getData("getSattlableGateways").then((res) => {
        this.gateways = res.result;
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تسویه حساب" }]);
    this.getdata();
  },
};
</script>